<template>
  <div class="bottom_page">
    <div class="model_box app-width modelh5">
      <div class="view">
        <div class="font_title">关于我们</div>
        <div class="font">公司简介</div>
        <div class="font">联系我们</div>
      </div>
      <div class="view">
        <div class="font_title">配送流程</div>
        <div class="font">产品签收</div>
        <div class="font">配送费用</div>
      </div>
      <div class="view">
        <div class="font_title">下单指南</div>
        <div class="font">服务条款</div>
        <div class="font">货期通知</div>
        <div class="font">印刷常见问题</div>
      </div>
      <div class="view">
        <div class="font_title">合作招商</div>
        <div class="font">合作招商</div>
        <div class="font">营销产品中心</div>
      </div>
      <div class="view">
        <div class="font_title">售后服务</div>
        <div class="font">售后服务说明</div>
        <div class="font">返工/退换货</div>
        <div class="font">退款说明</div>
        <div class="font">发票制度</div>
      </div>
      <div class="view">
        <div class="font_title">商家帮助</div>
        <div class="font">在线支付</div>
        <div class="font">下单常见问题</div>
        <div class="font">软件支持</div>
      </div>
      <div class="span">
        <!-- <div class="qrCode">
          <img
            src="http://vip.yin61.com/static/img/public_off_code.f6ff202.jpg"
            class="img"
          />
          <div class="content">扫一扫手机查看</div>
        </div>
        <div class="phone">0757-85632559</div>
        <div class="time">周一至周日 10:30-20:30</div> -->
      </div>
    </div>
    <div class="ba">
      <a href="http://beian.miit.gov.cn/"> 粤ICP备2025452067号</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: "#232830",
    },
  },
  data() {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: 480px) {
  .bottom_page {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;
    background: #ffffff;
  }
  .modelh5 {
    display: none;
  }
  .ba {
    text-align: center;
    font-size: 12px;
    color: #78808d;
  }
  a {
    color: #78808d;
    text-decoration-line: none;
  }
}
@media screen and (min-width: 480px) {
  .bottom_page {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;
    background: #232830;
  }
  .app-width {
    width: 1440px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .view {
    min-height: 130px;
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 30px;
    border-right: 1px solid #363b44;
  }
  .font_title {
    height: 34px;
    font-size: 15px;
    color: #fff;
    line-height: 34px;
    letter-spacing: 0.6px;
    margin: 0 16px;
  }
  .font {
    height: 34px;
    font-size: 14px;
    color: #78808d;
    line-height: 34px;
    letter-spacing: 0.6px;
    margin: 0 16px;
    cursor: pointer;
  }
  .ba {
    text-align: center;
    font-size: 12px;
    color: #78808d;
  }
  a {
    color: #78808d;
    text-decoration-line: none;
  }
  .span {
    position: absolute;
    top: 0;
    right: 30px;
  }
  .span {
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    align-items: center;
  }
  .qrCode {
    width: 106px;
    height: 124px;
    border-radius: 5px;
  }
  .img {
    width: 85px;
    height: 85px;
    margin: 6px 0;
  }
  .content {
    font-size: 12px;
    color: #fff;
  }
  .phone {
    font-size: 22px;
    color: #00a0e9;
    font-weight: 700;
    margin-top: 2px;
    white-space: nowrap;
  }
  .time {
    font-size: 12px;
    color: #78808d;
  }
}
</style>